<template>
  <b-row>
    <b-col
      cols="12"
      sm="4"
    >
      <Select2
        label="Empleado: "
        :options="employeesOp"
        reduce
        v-model="filters.employee"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
    >
      <DatePicker
        label="Fecha de Prestamo: "
        v-model="filters.loanDate"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
    >
      <DatePicker
        label="Fecha Inicio Desc: "
        v-model="filters.dateStart"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
    >
      <Select
        label="Frecuencia: "
        :options="frequencyOptions"
        v-model="filters.frequency"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
    >
      <Select
        label="Estado: "
        :options="STATUS_OPTIONS"
        v-model="filters.status"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
      class="text-right"
    >
      <b-button
        size="sm"
        variant="info"
        class="mt-4 mr-1"
        @click="$emit('search')"
      >
        <i class="fas fa-search mr-1 "/> Filtrar
      </b-button>
      <b-button
        size="sm"
        variant="dark"
        class="mt-4 ml-1"
        @click="$emit('clear')"
      >
        <i class="fas fa-ban mr-1" /> Limpiar
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

// components
import { Select2, Select, DatePicker } from '@/components/general'

// hooks
import { useEmployeesOp } from '@/hooks'

// constants
import { frequencyOptions } from '@/constants/generals'
import { STATUS_OPTIONS } from '@/constants/loanControl'

export default defineComponent({
  name: 'FiltersLoanControl',
  components: {
    Select,
    Select2,
    DatePicker
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup () {
    const { employeesOp } = useEmployeesOp()

    return {
      employeesOp,
      frequencyOptions,
      STATUS_OPTIONS
    }
  }
})
</script>
